// src/styles/components/index.js
import MuiCssBaseline from "./MuiCssBaseline";
import MuiButton from "./MuiButton";
import MuiIconButton from "./MuiIconButton";
import MuiTextField from "./MuiTextField";
import MuiPaper from "./MuiPaper";
import MuiCard from "./MuiCard";
import MuiAppBar from "./MuiAppBar";
import MuiAlert from "./MuiAlert";
import MuiChip from "./MuiChip";
import MuiDivider from "./MuiDivider";
import MuiAvatar from "./MuiAvatar";
import MuiGrid from "./MuiGrid";
import MuiStack from "./MuiStack";
import MuiTooltip from "./MuiTooltip";
import MuiSkeleton from "./MuiSkeleton";

import MuiTextInput from "./MuiTextInput";


const components = {
  MuiCssBaseline,
  MuiButton,
  MuiIconButton,
  MuiTextField,
  MuiPaper,
  MuiCard,
  MuiAppBar,
  MuiAlert,
  MuiChip,
  MuiDivider,
  MuiAvatar,
  MuiGrid,
  MuiStack,
  MuiTooltip,
  MuiSkeleton,
  
  MuiTextInput,
};

export default components;